"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axiosConfig_1 = __importDefault(require("./axiosConfig"));
var routerConfig_1 = __importDefault(require("./routerConfig"));
function default_1(_ajaxParams) {
    var ajaxParams = _ajaxParams;
    var ajaxTarget = new axiosConfig_1.default(ajaxParams);
    var routerParams = {
        axios: ajaxTarget.getAxiosTarget(),
        router: _ajaxParams.router || null,
        APPID: _ajaxParams.APPID,
        SYSTEM: _ajaxParams.SYSTEM,
        beforeExpel: _ajaxParams.beforeExpel,
        beforeEach: _ajaxParams.beforeEach
    };
    var routerTarget = new routerConfig_1.default(routerParams);
    return {
        ssoRouter: routerTarget,
        ssoAjax: ajaxTarget
    };
}
exports.default = default_1;
